export default "__VITE_ASSET__6928257a__"